import { UserRoundSearch, Plus } from 'lucide-react';
import { capitalize } from 'lodash';

import { EmptyBlock } from '@/components/ui/empty-block';
import { Card, CardTitle, CardHeader, CardContent, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';

type Props = {
  role: EscrowPartyTypeEnum;
};

const RepresentativesPlaceholder = ({ role }: Props) => {
  return (
    <Card className="flex flex-col opacity-50 pointer-events-none">
      <CardHeader className="shrink-0 min-h-[90px]">
        <CardTitle className="flex items-center gap-2">{capitalize(role)} representatives</CardTitle>
        <CardDescription>Who are the {role} key points of contact for this escrow?</CardDescription>
      </CardHeader>
      <CardContent className="grow">
        <EmptyBlock
          title="No representatives added"
          icon={UserRoundSearch}
          withCard={false}
          classes={{
            title: 'text-sm',
            content: 'h-full flex flex-col justify-center items-center',
          }}
          action={
            <Button variant="secondary">
              <Plus /> Add representative
            </Button>
          }
        />
      </CardContent>
    </Card>
  );
};

export default RepresentativesPlaceholder;
